<template>
  <div class="premiumchart_wrapper package_10000">
    <div class="title_wrapper">
      <!-- <div class="flex-center"> -->
      <h1>{{ kind }}USDT Smart Chart</h1>
      <!-- <p class="ticker">{{ kind }}USDT</p> -->
      <!-- </div> -->
      <div class="chart-type-selector">
        <div class="chart-tab flex-center">
          <!-- <label for="smLite" class="flex-center sm-tab-selector on">
            <input
              type="radio"
              id="smLite"
              name="sm-chart-select"
              checked
              value="smLite"
            />
            Lite
          </label>
          <label for="smPro" class="flex-center sm-tab-selector">
            <input
              type="radio"
              id="smPro"
              name="sm-chart-select"
              value="smPro"
            />
            Pro
          </label> -->

          <label
            v-for="tab in ['lite', 'pro']"
            :key="tab"
            :class="[
              'sm-tab-selector flex-center',
              { on: chartTabIndex === tab },
            ]"
          >
            <input
              type="radio"
              name="sm-chart-select"
              :id="'sm' + tab"
              :value="'sm' + tab"
              v-model="chartTabIndex"
              @change="onTabChange(tab)"
            />
            <img
              v-if="chartTabIndex === tab"
              src="@/assets/images/icons/check_orange.svg"
              alt=""
            />
            <img v-else src="@/assets/images/icons/check.svg" alt="" />
            {{ tab }}
          </label>
        </div>
      </div>
    </div>
    <div
      style="width: 100%"
      class="pm uo_wrapper"
      :class="{ new_uo_wrapper: !storeIsMobile }"
    >
      <div id="lightweight_uo" style="width: 100%; position: relative">
        <div class="autoScaleBox">
          <span class="autoScaleBtn">Auto</span>
        </div>
        <!-- <div class="loading-wrapper">
                        <div class="loading-container">
                            <img src="../image/loading.png"></img>
                            <p>Loading...</p>
                        </div>
                    </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { isMobile, checkDecimal } from "@/utils/chartUtil.js";
import {
  onMounted,
  onUnmounted,
  ref,
  defineProps,
  defineEmits,
  watch,
  onBeforeUnmount,
  computed,
  reactive,
  nextTick,
} from "vue";
import { getInitCandleLast } from "@/api/apiChart.js";
import pmChartOptions from "@/js/chart/smart/smart_chart_options.js";
import pmChartAPI from "@/js/chart/smart/smart_chart_api.js";
import { appendLegend, updateLegend } from "@/utils/chart/set_legend.js";
import {
  createToolBox,
  setAutoBtn,
  drawingToolHandler,
  fullScreenHandler,
  resizeOverlay,
  setupEventHandlers,
  createMeasureButton,
} from "@/utils/chart/set_tool_smart.js";
import { setCheckBoxLayout, setCheckBox } from "@/utils/chart/set_checkbox.js";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

const { t } = useI18n();

const state = reactive({ isFull: false, adjustedHeight: 0 });
const smIsHeikin = ref(false);
// const chartTabIndex = ref("lite");
const chartTabIndex = ref(localStorage.getItem("smChartTabIndex") || "lite");

const smCheckList = ref([]);
const checkedList = ref([]);
const pmChart = ref(null);
const candlestickSeries = ref(null);
const checkEl = ref();

const chart_wrapper = ref(null);
const pmContainer = ref(null);
const selectContainer = ref(null);

const pmChartAPIClass = new pmChartAPI();
const pmChartInstance = new pmChartOptions();
let isHeikin = false;
const store = useStore();
const storeIsMobile = computed(() => store.state.account.isMobile);
const props = defineProps({
  kind: String,
});

const kind = ref(props.kind);

// const kind = computed(() => store.getters["transact/getTicker"]);
const windowWidth = window.innerWidth;

const ogProSmCheckList = [
  {
    key: "SMARTCHANNEL",
    checked: true,
    value: "Smart Channel",
    desc: t("chart.smartChannelDesc"),
  },
  {
    key: "SMART",
    checked: false,
    value: "Smart Line",
    desc: t("chart.smartLineDesc"),
  },
  { key: "VOLV", checked: false, value: "Trend", desc: t("chart.trendDesc") },
  { key: "SR", checked: false, value: "S/R", desc: t("chart.srDesc") },
  {
    key: "CANDLE",
    checked: false,
    value: "Candle",
    desc: t("chart.smartCandleDesc"),
  },
  { key: "MA3", checked: false, value: "3MA", desc: t("chart.maDesc") },
  { key: "BB", checked: false, value: "BB", desc: t("chart.goyaLineDesc") },
  { key: "MACD", checked: false, value: "MACD", desc: t("chart.macdDesc") },
];
const ogLiteSmCheckList = [
  {
    key: "CANDLE",
    checked: false,
    value: "Candle",
    desc: t("chart.smartCandleDesc"),
  },
  { key: "VOLV", checked: false, value: "Trend", desc: t("chart.trendDesc") },
  {
    key: "TREND1",
    checked: false,
    value: "Trend 1",
    desc: t("chart.trend1Desc"),
  },
  {
    key: "SMART",
    checked: false,
    value: "Smart Line",
    desc: t("chart.smartLineDesc"),
  },
  {
    key: "PINK",
    checked: false,
    value: "GOYA LINE",
    desc: t("chart.goyaLineDesc"),
  },
  { key: "SR", checked: false, value: "S/R", desc: t("chart.srDesc") },
  { key: "All", checked: false, value: "All", desc: "" },
];

smCheckList.value = ogLiteSmCheckList;

let fetchList = [
  {
    key: "AO",
    series: [
      {
        name: "smAoSeries",
        type: "baseLine",
        option: "aoSeriesOptions",
        key: "ao",
      },
    ],
  },
  {
    key: "SMARTCHANNEL",
    series: [
      { name: "pinkLine", type: "line", option: "pinkOptions", key: "pink" },
    ],
  },
  {
    key: "UPPERLOWER",
  },
  {
    key: "MIDDLE",
  },
  {
    key: "FILLED",
  },
  {
    key: "PINK",
    series: [
      { name: "pinkLine", type: "line", option: "pinkOptions", key: "pink" },
    ],
  },
  {
    key: "CANDLE",
  },
  {
    key: "MA3",
    url: "ma",
    series: [
      { name: "MA1Line", type: "line", option: "Ma1Options", key: "ma1" },
      { name: "MA2Line", type: "line", option: "Ma2Options", key: "ma2" },
      { name: "MA3Line", type: "line", option: "Ma3Options", key: "ma3" },
    ],
  },
  {
    key: "BB",
    url: "bb",
    series: [
      { name: "UpperLine", type: "line", option: "UpperOptions", key: "upper" },
      { name: "LowerLine", type: "line", option: "LowerOptions", key: "lower" },
    ],
  },
  {
    key: "VOLV",
    url: "/analysis/multiple-trend",
    series: [
      {
        name: "trendUpper52",
        type: "line",
        option: "TrendUpper52Options",
        key: "upper",
        value: "52",
      },
      {
        name: "trendMiddle52",
        type: "line",
        option: "TrendMiddle52Options",
        key: "middle",
        value: "52",
      },
      {
        name: "trendLower52",
        type: "line",
        option: "TrendLower52Options",
        key: "lower",
        value: "52",
      },
      {
        name: "trendUpper100",
        type: "line",
        option: "TrendUpper100Options",
        key: "upper",
        value: "100",
      },
      {
        name: "trendMiddle100",
        type: "line",
        option: "TrendMiddle100Options",
        key: "middle",
        value: "100",
      },
      {
        name: "trendLower100",
        type: "line",
        option: "TrendLower100Options",
        key: "lower",
        value: "100",
      },
    ],
  },
  {
    key: "SMART",
    url: "/candle/senkoua-line",
    series: [
      {
        name: "senkouaLine",
        type: "line",
        option: "senkouaOptions",
        key: "senkoua",
      },
    ],
  },
  {
    key: "TREND",
    url: "/analysis/background-heikin",
    series: [
      { name: "trend", type: "area", option: "trend1Options", key: "hei" },
    ],
  },
  {
    key: "SR",
    url: "/candle/sr",
  },
  {
    key: "RSI",
    url: "/candle/rsi",
    series: [
      { name: "RSILine", type: "line", option: "RSILineOptions", key: "rsi" },
      {
        name: "MACDRSILineBlue",
        type: "line",
        option: "MACDRSILineBlueOptions",
        key: "blue_line",
      },
      {
        name: "MACDRSILineOrange",
        type: "line",
        option: "MACDRSILineOrangeOptions",
        key: "orange_line",
      },
    ],
  },
  {
    key: "MACD",
    url: "macd",
    series: [
      {
        name: "MACDHistogram",
        type: "histogram",
        option: "MACDHistogramOptions",
        key: "macd",
      },
      {
        name: "MACDLineBlue",
        type: "line",
        option: "MACDLineBlueOptions",
        key: "blue_line",
      },
      {
        name: "MACDLineOrange",
        type: "line",
        option: "MACDLineOrangeOptions",
        key: "orange_line",
      },
    ],
  },
];

let chart;

onMounted(async () => {
  chart_wrapper.value = document.querySelector(".pm.uo_wrapper");
  pmContainer.value = document.getElementById("lightweight_uo");
  selectContainer.value = document.createElement("div");
  selectContainer.value.className = "select_container browser premium";

  // 체크박스 초기화
  setCheckBox(
    chart_wrapper.value,
    smCheckList.value,
    "premium",
    selectContainer.value,
  );
  setCheckBoxLayout(
    chart_wrapper.value,
    pmContainer.value,
    smCheckList.value,
    "premium",
    state,
    selectContainer.value,
  );

  checkEl.value = chart_wrapper.value.querySelectorAll(
    "input[type='checkbox']",
  );
  checkedList.value = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ].map((e) => e.id);

  // window.addEventListener("resize", () => {
  //   setCheckBox(
  //     chart_wrapper.value,
  //     smCheckList.value,
  //     "premium",
  //     selectContainer.value
  //   );
  //   setCheckBoxLayout(
  //     chart_wrapper.value,
  //     pmContainer.value,
  //     smCheckList.value,
  //     "premium",
  //     state,
  //     selectContainer.value
  //   );
  //   chkBoxHandler();
  //   resizeOverlay(pmContainer.value, "smart");
  // });

  // 차트 및 시리즈 생성
  chkBoxHandler();

  await init(kind.value);

  await nextTick();

  let legend = document.createElement("div");
  appendLegend(pmContainer.value, "premium", legend);

  chart.subscribeCrosshairMove((param) => {
    // if (!chart || !candlestickSeries.value || !legend) return;
    updateLegend(param, candlestickSeries.value, legend, kind.value);
  });
  updateLegend(undefined, candlestickSeries.value, legend, kind.value);

  createToolBox(pmContainer.value);
  setAutoBtn(pmContainer.value, chart);
  drawingToolHandler(pmContainer.value, chart, candlestickSeries.value);
  fullScreenHandler(state, chart_wrapper.value, pmContainer.value, chart);
  setupEventHandlers(pmContainer.value, chart, candlestickSeries.value);
  createMeasureButton(pmContainer.value);

  window.addEventListener("resize", resizeHandler);
});

onUnmounted(() => {
  window.removeEventListener("resize", resizeHandler);
  clearInterval(intervalId);
});

function resizeHandler() {
  // 리사이즈 시 실행할 코드
  setCheckBox(
    chart_wrapper.value,
    smCheckList.value,
    "premium",
    selectContainer.value,
  );
  setCheckBoxLayout(
    chart_wrapper.value,
    pmContainer.value,
    smCheckList.value,
    "premium",
    state,
    selectContainer.value,
  );
  chkBoxHandler();
  resizeOverlay(pmContainer.value, "smart");
}

let eachsmCheckLists = {
  smpro: null,
  smlite: null,
};

async function resetIndicatorForSeries(seriesKeys) {
  for (const key of seriesKeys) {
    const chartObj = getSeries(key);
    if (chartObj && chartObj.series) {
      await pmChartAPIClass.resetIndicator(chartObj.series);
    }
  }
}

const onTabChange = async (tab) => {
  chartTabIndex.value = tab;

  await resetIndicatorForSeries(["SMARTCHANNEL", "PINK"]);

  eachsmCheckLists[chartTabIndex.value] = smCheckList.value;

  let exceptList = ["SMARTCHANNEL", "MA3", "BB", "MACD", "ALL"]; // for lite chart displaying (exclude checkbox)

  if (chartTabIndex.value == "pro") {
    smCheckList.value.forEach(async (chkBox) => {
      if (exceptList.includes(chkBox.key)) {
        // if (chkBox.key != "HEI") {
        await setEachIndicator(chkBox.key, false);
        // } else {
        //   await PmChartAPIClass.getCandle(kind, candlestickSeries, false);
        //   candlestickSeries.setData(candlestickSeries.data());
        // }
      }
    });
  }

  let savedProCheckedList = localStorage.getItem("smProCheckedList");
  let savedLiteCheckedList = localStorage.getItem("smLiteCheckedList");

  if (eachsmCheckLists[chartTabIndex.value]) {
    smCheckList.value = eachsmCheckLists[tab];

    if (chartTabIndex.value) {
      if (chartTabIndex.value == "pro") {
        // console.log("pro");

        smCheckList.value = ogProSmCheckList;

        await pmChartAPIClass.getCandleMarkers(
          kind.value,
          chart,
          candlestickSeries.value,
          checkedList.value,
          "pro",
        );

        if (savedProCheckedList) {
          savedProCheckedList = savedProCheckedList.split(",");

          if (!savedProCheckedList.includes("SMARTCHANNEL")) {
            // chart_wrapper.value.querySelector(`#PINK`).checked = false;
            smCheckList.value[0].checked = false;

            // smCheckList[0].checked = false;

            let chartObj = getSeries("SMARTCHANNEL");
            let seriesObj = chartObj.series;

            await pmChartAPIClass.resetIndicator(seriesObj);
          }

          smCheckList.value.forEach((checkbox) => {
            if (savedProCheckedList.includes(checkbox.key)) {
              checkbox.checked = true;
            }
          });

          pmChartAPIClass.setPriceScale(
            savedProCheckedList ? savedProCheckedList : ogProSmCheckList,
            { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
            chart,
          );

          await pmChartAPIClass.getFlagTrend(
            savedProCheckedList,
            getSeries("TREND"),
            kind.value,
          );
          const smIsHeikin = savedProCheckedList?.includes("CANDLE");

          await pmChartAPIClass.getCandle(
            kind.value,
            candlestickSeries.value,
            smIsHeikin,
          );
        }
      } else if (chartTabIndex.value == "lite") {
        // console.log("lite");
        smCheckList.value = ogLiteSmCheckList;

        // console.log(pmChart, chart);

        await resetIndicatorForSeries([
          "SMARTCHANNEL",
          "SMART",
          "VOLV",
          "SR",
          "CANDLE",
          "MA3",
          "BB",
          "MACD",
        ]);

        await pmChartAPIClass.getSmartLineData(
          kind,
          chart,
          false,
          "UPPERLOWER",
        );
        await pmChartAPIClass.getSmartLineData(kind, chart, false, "FILLED");

        if (savedLiteCheckedList) {
          savedLiteCheckedList = savedLiteCheckedList.split(",");

          smCheckList.value.forEach((checkbox) => {
            if (savedLiteCheckedList.includes(checkbox.key)) {
              checkbox.checked = true;
            }
          });

          pmChartAPIClass.setPriceScale(
            savedLiteCheckedList ? savedLiteCheckedList : ogLiteSmCheckList,
            { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
            chart,
          );

          await pmChartAPIClass.getFlagTrend(
            savedLiteCheckedList,
            getSeries("TREND"),
            kind.value,
          );

          const smIsHeikin = savedLiteCheckedList?.includes("CANDLE");

          await pmChartAPIClass.getCandle(
            kind.value,
            candlestickSeries.value,
            smIsHeikin,
          );
        }

        await pmChartAPIClass.getCandleMarkers(
          kind.value,
          chart,
          candlestickSeries.value,
          checkedList.value,
          "lite",
        );
      }
    }
  } else {
    // console.log(1);

    // watch(chartTabIndex.value, async (newData) => {
    //   if (newData == "pro") {
    //     console.log(12);
    //     smCheckList.value = ogProCheckList;

    //     if (savedProCheckedList) {
    //       savedProCheckedList = savedProCheckedList.split(",");

    //       if (!savedProCheckedList.includes("PREMIUMCHANNEL")) {
    //         // chart_wrapper.value.querySelector(`#PINK`).checked = false;
    //         smCheckList.value[0].checked = false;

    //         // smCheckList[0].checked = false;

    //         let chartObj = getSeries("PREMIUMCHANNEL");
    //         let seriesObj = chartObj.series;

    //         await pmChartAPIClass.resetIndicator(seriesObj);
    //       }

    //       smCheckList.value.forEach((checkbox) => {
    //         if (savedProCheckedList.includes(checkbox.key)) {
    //           checkbox.checked = true;
    //         }
    //       });

    //       pmChartAPIClass.setPriceScale(
    //         savedProCheckedList,
    //         { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
    //         chart
    //       );
    //     }

    //     const pmIsHeikin =
    //       smCheckList.value.find((item) => item.key === "HEI")?.checked ===
    //       true;

    //     await pmChartAPIClass.getCandle(
    //       kind.value,
    //       candlestickSeries.value,
    //       pmIsHeikin
    //     );
    //   } else if (newData == "lite") {
    //     smCheckList.value = ogLiteCheckList;

    //     if (savedLiteCheckedList) {
    //       savedLiteCheckedList = savedLiteCheckedList.split(",");
    //       if (!savedLiteCheckedList.includes("PINK")) {
    //         // chart_wrapper.value.querySelector(`#PINK`).checked = false;
    //         smCheckList.value[0].checked = false;

    //         // smCheckList[0].checked = false;

    //         let chartObj = getSeries("PINK");
    //         let seriesObj = chartObj.series;

    //         await pmChartAPIClass.resetIndicator(seriesObj);
    //       }

    //       smCheckList.value.forEach((checkbox) => {
    //         if (savedLiteCheckedList.includes(checkbox.key)) {
    //           checkbox.checked = true;
    //         }
    //       });

    //       pmChartAPIClass.setPriceScale(
    //         savedLiteCheckedList,
    //         { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
    //         chart
    //       );
    //     }

    //     await pmChartAPIClass.getCandle(
    //       kind.value,
    //       candlestickSeries.value,
    //       false
    //     );
    //   }
    // });

    // switch (chartTabIndex.value) {
    //   case "pro": {
    //     console.log(12);
    //     smCheckList.value = ogProCheckList;

    //     if (savedProCheckedList) {
    //       savedProCheckedList = savedProCheckedList.split(",");

    //       if (!savedProCheckedList.includes("PREMIUMCHANNEL")) {
    //         // chart_wrapper.value.querySelector(`#PINK`).checked = false;
    //         smCheckList.value[0].checked = false;

    //         // smCheckList[0].checked = false;

    //         let chartObj = getSeries("PREMIUMCHANNEL");
    //         let seriesObj = chartObj.series;

    //         await pmChartAPIClass.resetIndicator(seriesObj);
    //       }

    //       smCheckList.value.forEach((checkbox) => {
    //         if (savedProCheckedList.includes(checkbox.key)) {
    //           checkbox.checked = true;
    //         }
    //       });

    //       pmChartAPIClass.setPriceScale(
    //         savedProCheckedList,
    //         { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
    //         chart
    //       );
    //     }

    //     const pmIsHeikin =
    //       smCheckList.value.find((item) => item.key === "HEI")?.checked ===
    //       true;

    //     await pmChartAPIClass.getCandle(
    //       kind.value,
    //       candlestickSeries.value,
    //       pmIsHeikin.value
    //     );

    //     break;
    //   }
    //   case "lite": {
    //     smCheckList.value = ogLiteCheckList;

    //     if (savedLiteCheckedList) {
    //       savedLiteCheckedList = savedLiteCheckedList.split(",");
    //       if (!savedLiteCheckedList.includes("PINK")) {
    //         // chart_wrapper.value.querySelector(`#PINK`).checked = false;
    //         smCheckList.value[0].checked = false;

    //         // smCheckList[0].checked = false;

    //         let chartObj = getSeries("PINK");
    //         let seriesObj = chartObj.series;

    //         await pmChartAPIClass.resetIndicator(seriesObj);
    //       }

    //       smCheckList.value.forEach((checkbox) => {
    //         if (savedLiteCheckedList.includes(checkbox.key)) {
    //           checkbox.checked = true;
    //         }
    //       });

    //       pmChartAPIClass.setPriceScale(
    //         savedLiteCheckedList,
    //         { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
    //         chart
    //       );
    //     }

    //     await pmChartAPIClass.getCandle(
    //       kind.value,
    //       candlestickSeries.value,
    //       false
    //     );

    //     break;
    //   }
    // }

    const allChecked = smCheckList.value
      .slice(0, smCheckList.value.length - 1)
      .every((checkbox) => checkbox.checked);

    if (allChecked) {
      // "All" 체크박스도 체크하기
      const allCheckbox = smCheckList.value.find(
        (checkbox) => checkbox.key === "All",
      );
      if (allCheckbox) {
        allCheckbox.checked = true;
      }
    }
  }

  localStorage.setItem("smChartTabIndex", chartTabIndex.value);

  setCheckBox(
    chart_wrapper.value,
    smCheckList.value,
    "pm",
    selectContainer.value,
  );
  setCheckBoxLayout(
    chart_wrapper.value,
    pmContainer.value,
    smCheckList.value,
    "pm",
    state,
    selectContainer.value,
  );
  // console.log('smCheckList',smCheckList);
  smIsHeikin.value = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ]
    .map((e) => e.id)
    .includes("HEI");

  smCheckList.value.forEach(async (chkBox) => {
    if (chkBox.key == "All") {
      chart_wrapper.value.querySelector(`#${chkBox.key}`).checked =
        getChkBox("All").checked; // if all checked , need  to set all checkbox checked
    }
    if (chkBox.key != "HEI" && chkBox.key !== "TREND1") {
      await setEachIndicator(
        chkBox.key,
        chart_wrapper.value.querySelector(`#${chkBox.key}`).checked,
      );
    } else {
      // await pmChartAPIClass.getCandle(
      //   kind.value,
      //   candlestickSeries.value,
      //   chart_wrapper.value.querySelector(`#${chkBox.key}`).checked
      // );
      candlestickSeries.value.setData(candlestickSeries.value.data());
    }
  });
  checkedList.value = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ].map((e) => e.id);

  // await pmChartAPIClass.getCandleMarkers(
  //   kind,
  //   chart,
  //   candlestickSeries.value,
  //   checkedList.value,
  //   chartTabIndex.value
  // );

  pmChartAPIClass.displayCheckStatus(
    chartTabIndex.value,
    checkedList.value,
    fetchList,
  ); // charttab , macd , rsi, ao coditional displaying
  chkBoxHandler();
};

async function init(kind) {
  // 차트 생성

  const getInitCandleLastClose = await getInitCandleLast(kind);

  let priceFormat = checkDecimal(getInitCandleLastClose.close);
  chart = await pmChartInstance.createChart("lightweight_uo");

  if (pmChartInstance.chart) {
    const newHeight = windowWidth <= 576 || isMobile() ? 500 : 700;
    pmChartInstance.chart.resize(
      pmChartInstance.chartOptions.width || pmChartInstance.chartWidth || 0,
      newHeight,
    );
  }

  candlestickSeries.value = await pmChartInstance.createSeries(
    chart,
    "candle",
    "candleOptions",
    (priceFormat = ""),
  );

  const savedTab = localStorage.getItem("smChartTabIndex");
  // 체크리스트 저장값 불러오기
  let savedProCheckedList = localStorage.getItem("smProCheckedList");
  let savedLiteCheckedList = localStorage.getItem("smLiteCheckedList");

  await pmChartAPIClass.getCandle(
    kind,
    candlestickSeries.value,
    smIsHeikin.value,
  );

  fetchList.forEach((obj) => {
    // series들 생성
    if (obj["series"] && obj["series"].length > 0) {
      obj["series"].forEach((series) => {
        series["name"] = pmChartInstance.createSeries(
          chart,
          series.type,
          series.option,
          (priceFormat = ""),
          obj.key,
        );
      });
    }
    if (obj.key == "PINK" || obj.key == "AO" || obj.key == "SMARTCHANNEL") {
      pmChartAPIClass.getIndicator(kind, false, obj);
    }
  });
  await pmChartAPIClass.getMarkers(kind, getSeries("AO"));

  if (savedTab === "pro") {
    document.getElementById("smlite").parentElement.classList.remove("on");
    document.getElementById("smpro").parentElement.classList.add("on");

    document.querySelector("#smlite").checked = false;
    document.querySelector("#smpro").checked = true;
    chartTabIndex.value = "pro";

    // 기본 pro 체크박스 세팅
    smCheckList.value = ogProSmCheckList;

    // 체크박스 UI 그리기
    setCheckBox(
      chart_wrapper.value,
      smCheckList.value,
      "pm",
      selectContainer.value,
    );
    setCheckBoxLayout(
      chart_wrapper.value,
      pmContainer.value,
      smCheckList.value,
      "pm",
      state,
      selectContainer.value,
    );

    await pmChartAPIClass.getCandleMarkers(
      kind,
      chart,
      candlestickSeries.value,
      checkedList.value,
      "pro",
    );

    await resetIndicatorForSeries(["SMARTCHANNEL", "PINK"]);
    // 저장된 체크리스트 적용
    if (savedProCheckedList) {
      savedProCheckedList = savedProCheckedList.split(",");

      // 저장된 항목들 체크 상태 반영
      smCheckList.value.forEach((checkbox) => {
        checkbox.checked = savedProCheckedList.includes(checkbox.key);
      });

      const smIsHeikin = savedProCheckedList?.includes("CANDLE");

      await pmChartAPIClass.getCandle(
        kind,
        candlestickSeries.value,
        smIsHeikin,
      );

      await pmChartAPIClass.getCandle(
        kind,
        candlestickSeries.value,
        smIsHeikin,
      );
      await pmChartAPIClass.getMarkers(kind, getSeries("AO"));

      if (!savedProCheckedList.includes("SMARTCHANNEL")) {
        chart_wrapper.value.querySelector(`#SMARTCHANNEL`).checked = false;

        await pmChartAPIClass.getSmartLineData(
          kind,
          chart,
          false,
          "UPPERLOWER",
        );
        await pmChartAPIClass.getSmartLineData(kind, chart, false, "FILLED");
        let chartObj = getSeries("SMARTCHANNEL");

        if (chartObj?.series) {
          await pmChartAPIClass.resetIndicator(chartObj.series);
        }
      }

      checkedList.value = savedProCheckedList;

      // 보조지표 스케일 적용 (MACD, RSI용)
      pmChartAPIClass.setPriceScale(
        savedProCheckedList,
        { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
        chart,
      );

      pmChartAPIClass.displayCheckStatus(
        chartTabIndex.value,
        savedProCheckedList,
        fetchList,
      );
    }
  } else {
    // Lite 모드
    // $("#pro").parent().removeClass("on");
    document.getElementById("smpro").parentElement.classList.remove("on");

    // $("#lite").parent().addClass("on");
    document.getElementById("smlite").parentElement.classList.add("on");

    document.querySelector("#smpro").checked = false;
    document.querySelector("#smlite").checked = true;
    chartTabIndex.value = "lite";

    await resetIndicatorForSeries(["SMARTCHANNEL", "PINK"]);

    // 기본 lite 체크박스 세팅
    smCheckList.value = ogLiteSmCheckList;

    setCheckBox(
      chart_wrapper.value,
      smCheckList.value,
      "pm",
      selectContainer.value,
    );
    setCheckBoxLayout(
      chart_wrapper.value,
      pmContainer.value,
      smCheckList.value,
      "pm",
      state,
      selectContainer.value,
    );

    await pmChartAPIClass.getCandleMarkers(
      kind,
      chart,
      candlestickSeries.value,
      checkedList.value,
      "lite",
    );

    if (savedLiteCheckedList) {
      savedLiteCheckedList = savedLiteCheckedList.split(",");
      checkedList.value = savedLiteCheckedList;

      smCheckList.value.forEach((checkbox) => {
        checkbox.checked = savedLiteCheckedList.includes(checkbox.key);
      });

      const smIsHeikin = savedLiteCheckedList?.includes("CANDLE");

      await pmChartAPIClass.getCandle(
        kind,
        candlestickSeries.value,
        smIsHeikin,
      );
    }
  }

  // 최종 체크박스 상태 적용 + setEachIndicator 한번만 호출
  for (const chkBox of smCheckList.value) {
    const checkboxElement = chart_wrapper.value.querySelector(`#${chkBox.key}`);
    if (checkboxElement) {
      checkboxElement.checked = chkBox.checked;

      await setEachIndicator(chkBox.key, chkBox.checked);
    }
  }

  // All 체크박스 상태 자동 세팅
  const allChecked = smCheckList.value
    .slice(0, smCheckList.value.length - 1)
    .every((checkbox) => checkbox.checked);

  if (allChecked) {
    const allCheckbox = chart_wrapper.value.querySelector(`#All`);
    if (allCheckbox) {
      allCheckbox.checked = true;
    }
  }

  // 체크박스 이벤트 핸들러 등록
  chkBoxHandler();
}

function chkBoxHandler() {
  checkEl.value = chart_wrapper.value.querySelectorAll(
    "input[type='checkbox']",
  );
  // console.log('checkEl.value',checkEl.value);

  checkEl.value.forEach((chkBox) => {
    chkBox.addEventListener("change", async function () {
      let totalSmCheckList = smCheckList.value.map((e) => e.key);
      checkedList.value = [
        ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
      ].map((e) => e.id);
      smIsHeikin.value = [
        ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
      ]
        .map((e) => e.id)
        .includes("CANDLE");
      if (this.id == "All") {
        smIsHeikin.value = this.checked;
        await pmChartAPIClass.getCandle(
          kind.value,
          candlestickSeries.value,
          smIsHeikin.value,
        );
        smCheckList.value.forEach(async (chkBox) => {
          if (this.id == "All") {
            chart_wrapper.value.querySelector(`#${chkBox.key}`).checked =
              this.checked;
            chkBox.checked = this.checked;
          }

          getChkBox(chkBox.key).checked = this.checked;

          checkedList.value = [
            ...chart_wrapper.value.querySelectorAll(
              "input[type=checkbox]:checked",
            ),
          ].map((e) => e.id);

          await setEachIndicator(
            chkBox.key,
            chart_wrapper.value.querySelector(`#${chkBox.key}`).checked,
          );
        });

        candlestickSeries.value.setData(candlestickSeries.value.data());
      } else {
        if (this.id == "CANDLE") {
          if (isHeikin) {
            let candleCheckbox = chart_wrapper.value.querySelector(
              "input[type=checkbox]#HEI",
            );
            if (candleCheckbox) {
              candleCheckbox.checked = false;
            }

            isHeikin = false;

            const excludeIds = ["CANDLE", "FILLED", "UPPERLOWER", "MIDDLE"]; // 제외할 ID 리스트

            smCheckList.value.forEach(async (chkBox) => {
              if (!excludeIds.includes(chkBox.key)) {
                await setEachIndicator(
                  chkBox.key,
                  chart_wrapper.value.querySelector(`#${chkBox.key}`).checked,
                  false,
                );
              }
            });
          }
          const smIsHeikin = [
            ...chart_wrapper.value.querySelectorAll(
              "input[type=checkbox]:checked",
            ),
          ]
            .map((e) => e.id)
            .includes("CANDLE");

          await pmChartAPIClass.getCandle(
            kind.value,
            candlestickSeries.value,
            smIsHeikin,
          );
        } else {
          await setEachIndicator(this.id, this.checked, isHeikin);
        }
      }
      // all status check
      let isAllChecked = totalSmCheckList
        .filter((el) => el != "All")
        .every(
          (val) =>
            chart_wrapper.value.querySelector(`#${val}`).checked === true,
        );

      if (chart_wrapper.value.querySelector(`#All`)) {
        // "All" 체크박스 상태 동기화
        chart_wrapper.value.querySelector(`#All`).checked = isAllChecked;
        getChkBox("All").checked = isAllChecked;
      }

      // for priceScale after check rsi,macd
      pmChartAPIClass.setPriceScale(
        checkedList.value,
        { RSI: getSeries("RSI"), MACD: getSeries("MACD") },
        chart,
      );
      // display check status
      // if(chartTabIndex.value == 'pro'){
      pmChartAPIClass.displayCheckStatus(
        chartTabIndex.value,
        checkedList.value,
        fetchList,
      );
      // }
      // console.log('pmCheckList.find((id)=> id == this.id)',getChkBox(this.id));
      getChkBox(this.id).checked = this.checked;
      let savedTab = localStorage.getItem("smChartTabIndex");
      const filteredCheckedList = checkedList.value.filter(
        (item) => item !== "All",
      );

      savedTab === "pro"
        ? localStorage.setItem("smProCheckedList", filteredCheckedList)
        : localStorage.setItem("smLiteCheckedList", filteredCheckedList);
    });
  });
}

async function setEachIndicator(id, checked, isHeikin, forceUpdate = false) {
  let chartObj = getSeries(id);

  if (chartObj && Object.prototype.hasOwnProperty.call(chartObj, "series")) {
    let seriesObj = chartObj.series;
    if (id == "SMARTCHANNEL") {
      await pmChartAPIClass.getSmartLineData(
        kind.value,
        chart,
        checked,
        id,
        forceUpdate,
      );
    }

    if (checked) {
      if (id == "VOLV") {
        await pmChartAPIClass.getTrendLine(kind.value, chartObj);
      } else if (id == "MACD") {
        await pmChartAPIClass.getMACD(kind.value, isHeikin, chartObj);
      } else if (id == "RSI") {
        let macdSeries = getSeries("MACD").series;
        let isMacdLoad = await pmChartAPIClass.isInitLoad(
          macdSeries,
          isHeikin,
          "MACD",
        );
        // console.log('isMacdLoad',isMacdLoad);
        if (isMacdLoad) {
          await pmChartAPIClass.getMACD(
            kind.value,
            isHeikin,
            getSeries("MACD"),
            true,
          );
        }

        await pmChartAPIClass.getRSI(kind.value, isHeikin, chartObj);
      } else {
        await pmChartAPIClass.getIndicator(kind.value, isHeikin, chartObj);
      }
    } else {
      await pmChartAPIClass.resetIndicator(seriesObj);
    }
  } else {
    if (id == "SR") {
      await pmChartAPIClass.getSr(
        chartObj.url,
        kind.value,
        candlestickSeries.value,
        checked,
      );
    } else if (id == "TREND1" || id == "TREND2") {
      await pmChartAPIClass.getFlagTrend(
        checkedList.value,
        getSeries("TREND"),
        kind.value,
      );
    }
  }
}

function getChkBox(id) {
  return smCheckList.value.find((obj) => obj.key == id);
}

function getSeries(id) {
  return fetchList.find((obj) => obj.key == id);
}

let intervalId = setInterval(async () => {
  await pmChartAPIClass.updateChart(fetchList);
  isHeikin = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ]
    .map((e) => e.id)
    .includes("HEI");

  const smIsHeikin = [
    ...chart_wrapper.value.querySelectorAll("input[type=checkbox]:checked"),
  ]
    .map((e) => e.id)
    .includes("CANDLE");

  await pmChartAPIClass.getCandle(kind.value, candlestickSeries.value, false);

  if (smIsHeikin) {
    await pmChartAPIClass.getCandle(
      kind.value,
      candlestickSeries.value,
      smIsHeikin,
    );
  }

  candlestickSeries.value.setData(candlestickSeries.value.data());

  smCheckList.value.forEach(async (chkBox) => {
    const isChecked = chart_wrapper.value.querySelector(
      `#${chkBox.key}`,
    ).checked;

    if (isChecked) {
      await setEachIndicator(
        chkBox.key,
        chart_wrapper.value.querySelector(`#${chkBox.key}`).checked,
        isHeikin,
        true,
      );
    }
  });

  await pmChartAPIClass.getMarkers(kind.value, getSeries("AO"));

  await pmChartAPIClass.getCandleMarkers(
    kind.value,
    chart,
    candlestickSeries.value,
    checkedList.value,
    chartTabIndex.value,
    true,
  );

  let savedProCheckedList = localStorage.getItem("smProCheckedList");
  if (savedProCheckedList) {
    savedProCheckedList = savedProCheckedList.split(",");
  }

  pmChartAPIClass.displayCheckStatus(
    chartTabIndex.value,
    savedProCheckedList ? savedProCheckedList : checkedList.value,
    fetchList,
  );
}, 300000);
//300000
</script>

<style scoped>
@import "@/assets/css/renewal_design.css";
@import "@/assets/css/setting_design.css";

.new_uo_wrapper {
  height: 700px !important;
}
</style>
